import { Component, inject } from '@angular/core';
import { IonButton, IonIcon, IonModal } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  expandOutline,
  homeOutline,
  notificationsOutline,
  phonePortraitOutline,
  shareOutline,
} from 'ionicons/icons';
import { AppBrandLogoComponent } from '../common/components/app-brand-logo/app-brand-logo.component';
import { TRANSLATE_IMPORTS } from '../i18n/translate-imports';
import { UsePwaService } from './pwa-service';

addIcons({
  phonePortraitOutline,
  shareOutline,
  notificationsOutline,
  homeOutline,
  expandOutline,
});

@Component({
  selector: 're-pwa-install-modal',
  templateUrl: './pwa-install-modal.component.html',
  styleUrl: './pwa-install-modal.component.scss',
  imports: [IonModal, IonIcon, IonButton, AppBrandLogoComponent, ...TRANSLATE_IMPORTS],
})
export class PwaInstallModalComponent {
  readonly pwa = inject(UsePwaService);

  /** Block backdrop/swipe; allow programmatic close when isOpen becomes false. */
  readonly canDismissModal = async (
    _data?: unknown,
    role?: string,
  ): Promise<boolean> => role !== 'backdrop' && role !== 'gesture';

  onDidDismiss(): void {
    this.pwa.closeModal();
  }
}
